import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';
import { ApiResponse } from '../shared/types';

export interface PublicFeedbackSubmitPayload {
  feedbackId: string;
  token: string;
  rating: number;
  comment?: string;
}

export interface PublicFeedbackContextResult {
  feedbackId: string;
  companyName: string | null;
  companyLogo: string | null;
  googleReviewUrl: string | null;
}

export interface PublicFeedbackSubmitResult {
  feedbackId: string;
  orderId: string;
  rating: number;
  comment: string | null;
  status: string;
  submittedAt: string;
  googleReviewUrl: string | null;
}

/**
 * Unauthenticated client for the post-wash SMS feedback public API.
 * POST /api/v1/order/public/feedback/context — load branding
 * POST /api/v1/order/public/feedback — submit rating
 */
@Injectable({ providedIn: 'root' })
export class FeedbackPublicService {
  constructor(private readonly api: ApiService) {}

  loadContext(params: {
    feedbackId: string;
    token: string;
  }): Observable<ApiResponse<PublicFeedbackContextResult>> {
    return this.api.postWithoutAuth<PublicFeedbackContextResult>(
      'order/public/feedback/context',
      {
        feedbackId: params.feedbackId,
        token: params.token,
      }
    );
  }

  submit(
    payload: PublicFeedbackSubmitPayload
  ): Observable<ApiResponse<PublicFeedbackSubmitResult>> {
    return this.api.postWithoutAuth<PublicFeedbackSubmitResult>('order/public/feedback', {
      feedbackId: payload.feedbackId,
      token: payload.token,
      rating: payload.rating,
      comment: payload.comment ?? '',
    });
  }
}
